import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

const HEADER_VARIATIONS : Record<
  AssessmentType,
  Partial<Record<FieldType, string[]>>
  > = {
  MClass: {
    sld: [
      "SLD",
      "Specific Learning Disability? (Y or N)",
      "SLD Status",
      "Specific Disability",
    ],
    specialEducation: ["Special Education"],
    ell: ["ELL", "ELL? (Y or N)", "ELL Status"],
    lunch: [
      "Meal Status",
      "Free or Reduced Lunch",
      "Free/Reduced Lunch? (Y or N)",
    ],
  },

  LinkIt: {
    sld: ["SLD", "Specific Learning Disability? (Y or N)"],
    specialEducation: ["Special Education"],
    ell: ["ELL", "ELL? (Y or N)"],
    lunch: [
      "Free or Reduced Lunch",
      "Free/Reduced Lunch? (Y or N)",
    ],
  },

  NJTSS: {
    sld: ["SLD"],
    specialEducation: ["Special Education"],
    ell: ["ELL"],
    lunch: ["Free or Reduced Lunch"],
  },

  DDMS: {
    sld: ["SLD"],
    specialEducation: ["Special Education"],
    ell: ["ELL"],
    lunch: ["Free or Reduced Lunch"],
  },

  DESSA: {
    gender: ["StudentGender"],
    specialEducation: ["SpecialEdSvc"],
    ell: ["EngLangLearn"],
    lunch: ["FreeReduced"],
  },
};

type AssessmentType =
  | "MClass"
  | "LinkIt"
  | "NJTSS"
  | "DDMS"
  | "DESSA";

type FieldType =
  | "sld"
  | "specialEducation"
  | "ell"
  | "lunch"
  | "gender";

interface DemographicAdditionalContentProps {
  assessmentType?: AssessmentType;
  field?: FieldType;
  isValue?: boolean;
}

const DemographicAdditionalContent = ({
  assessmentType,
  field,
  isValue = false,
}: DemographicAdditionalContentProps) => {
  const getValueItems = (field?: FieldType) => {
  if (field && (field === "lunch")) return ["Yes / No", "Y / N", "F", "Blank allowed"];
  if (field && (field === "gender")) return ["Male / Female", "M / F", "X", "Blank allowed"];
  if (field && (['sld', 'ell', 'specialEducation'].includes(field))) return ["Yes / No", "Y / N", "Blank allowed"];
  return ["Yes / No", "Y / N"];
  };

  const valueContent = {
    title: "Accepted values for this field (case-insensitive)",
    items: getValueItems(field),
  };

  const fieldTitles = {
    sld: "Accepted header variation for SLD (case-insensitive)",
    specialEducation:
      "Accepted header variation for Special Education (case-insensitive)",
    ell: "Accepted header variation for ELL (case-insensitive)",
    lunch:
      "Accepted header variation for Free or Reduced Lunch (case-insensitive)",
    gender:
      "Accepted header variation for Gender (case-insensitive)",
  };

  const content = isValue
    ? valueContent
    : {
        title: field ? fieldTitles[field] : "",
        items: assessmentType && field ? HEADER_VARIATIONS[assessmentType]?.[field] || [] : [],
      };
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Popover id="accepted-values">
          <Popover.Content>
            <div>
              <strong>{content.title}</strong>
              <ul className="mb-0 pl-3">
                {content.items.map((item: string) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </Popover.Content>
        </Popover>
      }
    >
      <FontAwesomeIcon
        icon={faQuestionCircle}
        size="1x"
        style={{ color: "#00265b", cursor: "pointer" }}
        className="mx-1"
      />
    </OverlayTrigger>
  );
};

export default DemographicAdditionalContent;
